export default __webpack_public_path__ + "static/media/patient.b8dcf49a.svg";